(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dalisel-choice-journey"] && !Shopify.designMode) return;
  try {
    
  const initializeDaliselJourney = (root) => {
    const sliders = root.matches?.('[data-dalisel-journey]') ? [root] : root.querySelectorAll?.('[data-dalisel-journey]');
    sliders?.forEach((slider) => {
      if (slider.dataset.ready === 'true') return;
      slider.dataset.ready = 'true';
      const track = slider.querySelector('[data-dalisel-journey-track]');
      const slides = [...slider.querySelectorAll('[data-dalisel-journey-slide]')];
      const count = slider.querySelector('[data-dalisel-journey-count]');
      const progress = slider.querySelector('[data-dalisel-journey-progress]');
      const previous = slider.querySelector('[data-dalisel-journey-prev]');
      const next = slider.querySelector('[data-dalisel-journey-next]');
      if (!track || slides.length === 0) return;
      let current = 0;
      let frame;

      const formatCount = (value) => String(value).padStart(2, '0');
      const update = () => {
        const trackLeft = track.getBoundingClientRect().left;
        current = slides.reduce((nearest, slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          const nearestDistance = Math.abs(slides[nearest].getBoundingClientRect().left - trackLeft);
          return distance < nearestDistance ? index : nearest;
        }, 0);
        if (count) count.textContent = `${formatCount(current + 1)} / ${formatCount(slides.length)}`;
        if (progress) progress.style.width = `${((current + 1) / slides.length) * 100}%`;
        if (previous) previous.disabled = current === 0;
        if (next) next.disabled = current === slides.length - 1;
      };

      const go = (index) => {
        const target = slides[Math.max(0, Math.min(index, slides.length - 1))];
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };

      previous?.addEventListener('click', () => go(current - 1));
      next?.addEventListener('click', () => go(current + 1));
      slides.forEach((slide, index) => slide.querySelector('[data-dalisel-slide-next]')?.addEventListener('click', () => go(index + 1)));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      }, { passive: true });
      update();
    });
  };

  initializeDaliselJourney(document);
  document.addEventListener('shopify:section:load', (event) => initializeDaliselJourney(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dalisel-ritual-day"] && !Shopify.designMode) return;
  try {
    
  const initializeDaliselRitualDay = (root) => {
    const sections = root.matches?.('[data-dalisel-ritual-day]') ? [root] : root.querySelectorAll?.('[data-dalisel-ritual-day]');
    sections?.forEach((section) => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      const tabs = [...section.querySelectorAll('[data-dalisel-ritual-tab]')];
      const panels = [...section.querySelectorAll('[data-dalisel-ritual-panel]')];

      const activate = (tab) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
          if (panel.hidden) {
            panel.querySelectorAll('video').forEach((video) => video.pause());
            panel.querySelectorAll('[data-dalisel-video-toggle]').forEach((button) => button.classList.remove('is-playing'));
          }
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let target = index;
          if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;
          activate(tabs[target]);
          tabs[target].focus();
        });
      });

      section.querySelectorAll('[data-dalisel-video-toggle]').forEach((button) => {
        const video = button.closest('.dalisel-ritual-day__media')?.querySelector('video');
        if (!video) return;
        button.addEventListener('click', () => {
          if (video.paused) {
            video.play().then(() => button.classList.add('is-playing')).catch(() => button.classList.remove('is-playing'));
          } else {
            video.pause();
            button.classList.remove('is-playing');
          }
        });
        video.addEventListener('ended', () => button.classList.remove('is-playing'));
      });

      section.querySelectorAll('[data-dalisel-wrist-viewer]').forEach((viewer) => {
        const panel = viewer.closest('[data-dalisel-ritual-panel]');
        const count = panel?.querySelector('[data-dalisel-angle-count]');
        let frame = Number(viewer.dataset.frame || 0);
        let pointerStart = null;

        const renderFrame = () => {
          frame = (frame + 4) % 4;
          viewer.dataset.frame = String(frame);
          if (count) count.textContent = `${frame + 1} / 4`;
        };

        const setTone = (button) => {
          const tone = button.dataset.daliselTone;
          const url = viewer.dataset[`sheet${tone.charAt(0).toUpperCase()}${tone.slice(1)}`];
          viewer.dataset.tone = tone;
          panel.querySelectorAll('[data-dalisel-tone]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          if (url) {
            viewer.style.setProperty('--dalisel-wrist-sheet', `url("${url}")`);
            viewer.classList.remove('is-placeholder');
          } else {
            viewer.style.removeProperty('--dalisel-wrist-sheet');
            viewer.classList.add('is-placeholder');
          }
        };

        panel?.querySelectorAll('[data-dalisel-tone]').forEach((button) => button.addEventListener('click', () => setTone(button)));
        panel?.querySelector('[data-dalisel-rotate-prev]')?.addEventListener('click', () => { frame -= 1; renderFrame(); });
        panel?.querySelector('[data-dalisel-rotate-next]')?.addEventListener('click', () => { frame += 1; renderFrame(); });
        viewer.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          frame += event.key === 'ArrowRight' ? 1 : -1;
          renderFrame();
        });
        viewer.addEventListener('pointerdown', (event) => {
          pointerStart = event.clientX;
          viewer.setPointerCapture(event.pointerId);
        });
        viewer.addEventListener('pointerup', (event) => {
          if (pointerStart === null) return;
          const distance = event.clientX - pointerStart;
          pointerStart = null;
          if (Math.abs(distance) < 24) return;
          frame += distance < 0 ? 1 : -1;
          renderFrame();
        });
        renderFrame();
      });

      section.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-dalisel-ritual-panel]');
        if (!panel) return;
        const tab = tabs.find((item) => item.getAttribute('aria-controls') === panel.id);
        if (tab) activate(tab);
      });
    });
  };

  initializeDaliselRitualDay(document);
  document.addEventListener('shopify:section:load', (event) => initializeDaliselRitualDay(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
